import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import icSearch from '../../../images/ic_search.png';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import Loading from '../../../common/components/Loading/Loading';
import actions from '../../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TableHeader from '../../../common/components/ItemTable/TableHeader';
import TableRow from '../../../common/components/ItemTable/TableRow';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import ListPaginator from '../../../common/components/ListPaginator/ListPaginator';
import _ from 'lodash';
import Chip from '../../../common/components/Chip/Chip';
import './MedicalServiceList.scss';
import help from '../../../images/help_h.png';
import Modal from '../../../common/components/Modal/Modal';
import arrowBack from '../../../images/back_arrow_left_icon.svg';

const MedicalServiceList = (props) => {
    const {
        name,
        title,
        switchOfUser,
        getAllMedicalServices,
        allMedicalServices,
        getAllMedicalServicesState,
        affiliateSelected,
        affiliateData,
        approveAttention,
        setAttentionForCreate,
        attentionForCreate,
        branchesProviders,
        allMedicalServicesConfig,
        setListConfig,
        cleanListConfig,
        branches,
        attentionsSelected,
        setAttentionsSelected,
        userInfo,
        showSidebar,
    } = props;
    const history = useHistory();

    const [currentPage, setCurrentPage] = useState(-1);
    const [allChecked, setAllChecked] = useState(false);

    const pageQuantity = Math.ceil(allMedicalServices?.totalCount/allMedicalServicesConfig.size);

    const isInitialMount = useRef(true);

    const listData = [
        {title: '', component: (medicalService) => checkButton(medicalService), width: '20%'},
        {title: 'DESCRIPCIÓN', att: 'medicalServiceDescription', width: '40%', sort: true},
        {title: 'CÓDIGO', att: 'medicalServiceCode', width: '20%', center: true, centerTitle: true, sort: true},
        {title: 'RUBRO', att: 'medicalServiceCategory', width: '40%', sort: true},
    ];

    const listDataHeaders = [
        {title: '', component: () => checkButtonHeaders(), width: '5%', center: true, allRows: true},
        {title: 'DESCRIPCIÓN', att: 'medicalServiceDescription', width: '30%', sort: true},
        {title: 'CÓDIGO', att: 'medicalServiceCode', width: '20%', center: true, centerTitle: true, sort: true},
        {title: 'RUBRO', att: 'medicalServiceCategory', width: '40%', sort: true},
    ];

    const tagNames = {
        medicalServiceName: 'DESCRIPCIÓN',
        medicalServiceCode: 'CÓDIGO',
        medicalServiceCategory: 'RUBRO',
    };
    const filters = [
        'Laboratorio', 'Imagenes', 'Consultas', 'Practicas y Estudios', 'Otros',
    ];

    const [search, setSearch] = useState('');
    const [searchTag, setSearchTag] = useState('');
    const [category, setCategory] = useState('');
    const [provider, setProvider] = useState(branches?.find( ( branch ) => branch.providerId === attentionForCreate.salesforceProviderId)?.fullName);
    const [branch, setBranch] = useState(branchesProviders?.find( ( branch ) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);

    const [showHelper, setShowHelper] = useState(false);

    const handleHelper = () => {
        setShowHelper(!showHelper);
    };

    const handleCategorySelect = (e) => {
        setCategory(category === e.target.value ? '' : e.target.value);
        setAllChecked(false);
    };

    const handleSearch = () => {
        setCategory('');

        const searchTags={...allMedicalServicesConfig.searchTags, [searchTag||'medicalServiceName']: search};

        setListConfig( {
            list: 'allMedicalServicesConfig',
            config: {search: search, searchTags, page: 1},
        } );
        getAllMedicalServices();

        setSearch('');
    };

    useEffect(() => {
        switchOfUser('Prestaciones');
        switch (userInfo.role.name) {
            case 'ADMIN':
                setProvider(branches?.find( ( branch ) => branch.providerId === attentionForCreate.salesforceProviderId)?.fullName);
                setBranch(branchesProviders?.find( ( branch ) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
                break;
            case 'PROVIDER_ADMIN':
                setProvider(userInfo.salesforceProviderName);
                setBranch(branchesProviders?.find( ( branch ) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
                break;
            case 'PROVIDER_USER':
                setProvider(userInfo.salesforceProviderName);
                setBranch(userInfo.salesforceBranchName);
                break;
            default:
                break;
        }
        cleanListConfig('allMedicalServicesConfig');
        setCurrentPage( allMedicalServicesConfig?.page ?? -1 );
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (category !== '') {
            setListConfig({
                list: 'allMedicalServicesConfig',
                config: {category: category, page: 1},
            });
            getAllMedicalServices();
        }
        // eslint-disable-next-line
    }, [category]);

    useEffect(()=> {
        if ( !isInitialMount.current || allMedicalServicesConfig === undefined ) {
            const planName = affiliateData.filter((x) => x.status === 'Activo')[0].plans[0].name;
            setListConfig( {
                list: 'allMedicalServicesConfig',
                config: {page: currentPage, planName: planName},
            } );
            getAllMedicalServices();
        }
        isInitialMount.current = false;
        setAllChecked(false);
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect( ()=>{
        if ( currentPage > pageQuantity ) setCurrentPage( pageQuantity );
        // eslint-disable-next-line
    }, [allMedicalServices] );

    const deleteSearchTag = ( tag ) => {
        const searchTags= _.omit( allMedicalServicesConfig?.searchTags, [tag] );

        setListConfig( {
            list: 'allMedicalServicesConfig',
            config: {search: search, searchTags},
        } );
        getAllMedicalServices();
    };

    const handleBack = (e) => {
        e.preventDefault();
        history.goBack();
    };

    const sortList = (param)=>{
        const element = allMedicalServicesConfig?.orderBy?.find((e) => e?.param === param);
        const newElement = {
            param,
            ord: element?.ord === 'asc' ? 'desc' : 'asc',
        };
        const orderBy = [newElement];

        setListConfig( {
            list: 'allMedicalServicesConfig',
            config: {orderBy},
        } );

        getAllMedicalServices();
    };

    const resetFilters = () => {
        cleanListConfig('allMedicalServicesConfig');
        const searchTags = [];
        const planName = affiliateData.filter((x) => x.status === 'Activo')[0].plans[0].name;
        setListConfig( {
            list: 'allMedicalServicesConfig',
            config: {search: '', searchTags, planName: planName},
        } );
        setCategory('');
        isInitialMount.current = true;
        getAllMedicalServices();
    };

    const checkButton = (medicalService) => {
        const handleCheck = (isChecked) => {
            if (isChecked && !medicalService.checked) {
                setAttentionsSelected([...attentionsSelected, medicalService]);
            } else {
                setAttentionsSelected(attentionsSelected.filter((x) => x.medicalServiceId !== medicalService.medicalServiceId));
            }
            medicalService.checked = isChecked;
        };
        return (
            <input
                type='checkbox'
                onChange={(e) => handleCheck(e.target.checked)}
                checked={medicalService.checked || allChecked}
                className="largeCheckbox"
            />
        );
    };

    const checkButtonHeaders = () => {
        const handleCheckHeaders = (isChecked) => {
            try {
                if (isChecked && !allChecked) {
                    setAttentionsSelected([...attentionsSelected, ...allMedicalServices.results]);
                    // setAttentionsSelected([...allMedicalServices]);
                } else {
                    setAttentionsSelected([]);
                }
            } catch (error) {
                console.log('bad ', error);
            }
            setAllChecked(isChecked);
        };
        return (
            <input
                type='checkbox'
                onChange={(e) => handleCheckHeaders(e.target.checked)}
                checked={allChecked}
                className="largeCheckbox"
            />
        );
    };

    const approveMultiple = () => {
        const body = {
            ...attentionForCreate,
            medicalServicesIds: attentionsSelected.map((x) => x.medicalServiceId),
            document: affiliateSelected.searchTag === 'document' ? affiliateSelected.affiliate : null,
            affiliateNumber: affiliateSelected.searchTag === 'affiliateNumber' ? affiliateSelected.affiliate : null,
        };
        setAttentionForCreate(body);
        approveAttention(_.omit( body, ['salesforceProviderId'] ));
        history.push('createAttention');
    };

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <div className="ul-div-header-section">
                <button onClick={handleBack}>
                    <img
                        src={arrowBack}
                        alt={'<'}
                    />
                </button>
                <p className="ul-p-name">{name}</p>
            </div>
            <div className="ul-div-affiliate-container">
                <div className="ul-div-info-container">
                    <div>
                        <p className="ul-p-title">DATOS DEL PACIENTE</p>
                        <hr id="id-hr"/>
                    </div>
                    <div className="ul-div-affiliate-data-container">
                        <div className="ul-div-affiliate-data">
                            <h3>NOMBRE</h3>
                            <p>
                                {
                                    affiliateData[0].fullName
                                }
                            </p>
                        </div>
                        <div className="ul-div-affiliate-data">
                            <h3>{affiliateSelected.searchTag === 'document' ? 'DOCUMENTO' : 'CREDENCIAL' }</h3>
                            <p>
                                {

                                }
                            </p>
                        </div>
                    </div>
                </div>
                <div className="ul-div-info-container">
                    <div>
                        <p className="ul-p-title">DATOS DEL PRESTADOR</p>
                        <hr id="id-hr"/>
                    </div>
                    <div className="ul-div-affiliate-data-container">
                        <div className="ul-div-affiliate-data">
                            <h3>PRESTADOR</h3>
                            <p>
                                {provider}
                            </p>
                        </div>
                        <div className="ul-div-affiliate-data">
                            <h3>SEDE</h3>
                            <p>
                                {branch}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="ul-div-info-container">
                    <div>
                        <p className="ul-p-title">DATOS DEL SERVICIO</p>
                        <hr id="id-hr"/>
                    </div>
                    <div className="ul-div-affiliate-data-container">
                        <div className="ul-div-affiliate-data" style={{width: '100%', maxHeight: '100px', overflowX: 'auto'}}>
                            <h3>NOMBRE</h3>
                            {attentionsSelected && attentionsSelected.map((att) =>(
                                // eslint-disable-next-line react/jsx-key
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 1}}>
                                    <p>
                                        {att.medicalServiceName || att.medicalServiceId}
                                    </p>
                                    <Ebutton
                                        onClick={() =>
                                            setAttentionsSelected(attentionsSelected.filter((x) => x.medicalServiceId !== att.medicalServiceId))
                                        }
                                        type='button'
                                        text='x'
                                    />
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div className="mb-5">
                        <p className="ul-p-title">{title.toUpperCase()} <img src={help} alt={'help'} style={{'maxHeight': '20px', 'justifySelf': 'center', 'alignSelf': 'center', ':hover': {cursor: 'pointer'}}} onClick={()=> handleHelper()}></img></p>
                        <hr id="id-hr"/>
                    </div>
                    <div>
                        <form onSubmit={(event)=>{
                            handleSearch();
                            event.preventDefault();
                        }} >
                            <div className="ul-div-serchCont">
                                 <div className="ul-div-tagSel">
                                    <select
                                        style={{width: '220px'}}
                                        className="ul-div-searchbar"
                                        onChange={(e) => setSearchTag(e.target.value)}
                                        defaultValue={'medicalServiceName'}
                                    >
                                        <option value={'medicalServiceName'} selected="selected" >{tagNames['medicalServiceName']}</option>
                                        <option value={'medicalServiceCode'} >{tagNames['medicalServiceCode']}</option>
                                        <option value={'medicalServiceCategory'} >{tagNames['medicalServiceCategory']}</option>
                                    </select>
                                 </div>
                                <div className="ul-div-searchbar">
                                    <input
                                        placeholder="Buscar atención"
                                        value={search}
                                        onChange={(e) => {
                                            setSearch(e.target.value);
                                        }}
                                    />
                                    <button type='submit'><img src={icSearch} alt={'search'}/></button>
                                </div>
                            </div>
                            <div className="msl-radio-container">
                                {filters.map((filter) => {
                                return (
                                    <>
                                        <input
                                            type='radio'
                                            value = {filter.toUpperCase()}
                                            name={filter.slice(0, 4)}
                                            className='msl-radio'
                                            onChange={(e) => handleCategorySelect(e)}
                                            checked={category === filter.toUpperCase()}
                                            />{filter}
                                    </>
                                );
                                    })}
                                <Ebutton classNameButton="ml-50" type='button' onClick={() => resetFilters()}
                                         text="Borrar filtros"/>
                            </div>
                        </form>
                    </div>
                </div>
                <div>
                    <Ebutton
                        classNameButton="ul-btn"
                        type="button"
                        onClick={() => approveMultiple()}
                        disabled={attentionsSelected?.length <= 0}
                        text="Consultar"/>
                    { allMedicalServicesConfig?.searchTags && Object.keys(allMedicalServicesConfig?.searchTags).map( (key)=>
                        <Chip
                            key={key}
                            text={tagNames[key]+': '+allMedicalServicesConfig?.searchTags[key]}
                            event={ ()=>{
                                deleteSearchTag(key);
                            } }
                        />,
                    )
                    }
                </div>

                <div className="ul-div-sect-table">
                    { getAllMedicalServicesState.success ?
                        <table className="ul-div-table">
                            <TableHeader listData={listDataHeaders} sortList={sortList} sortParam={allMedicalServicesConfig.orderBy} allRows={true}/>
                            <tbody>
                            {
                                allMedicalServices?.results.length <= 0 && !getAllMedicalServicesState.loading ?
                                    <tr><td colSpan={100} ><CustomAlert text='atenciones' /></td></tr> :
                                    allMedicalServices?.results.map((item, index) =>
                                        <TableRow key={index} listData={listData} data={item}/>,
                                    )
                            }
                            </tbody>
                        </table> :
                        getAllMedicalServicesState.loading?<Loading className="ul-div-sect-table" />:
                            <CustomAlert text={'atenciones' || String(getAllMedicalServicesState.error)} severity='error' />
                    }
                    <div className="ul-div-bottom">
                        <ListPaginator
                            pageQuantity={pageQuantity}
                            currentPage={allMedicalServicesConfig.page}
                            setCurrentPage={setCurrentPage}
                            initInOne={true}
                        />
                    </div>
                </div>

            </div>
            {showHelper && (
                <Modal
                    showModal={showHelper}
                    handleClose={()=>setShowHelper(false)}
                    handleClick={()=> handleHelper()}
                    modalText={`Seleccione las prestaciones y luego presione consultar para avanzar con el registro`}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    allMedicalServices: state.home.allMedicalServices,
    getAllMedicalServicesState: state.home.getAllMedicalServicesState,
    affiliateSelected: state.home.affiliateSelected,
    affiliateData: state.home.affiliates,
    attentionForCreate: state.home.attentionForCreate,
    branchesProviders: state.home.branchesProviders,
    branches: state.home.branches,
    allMedicalServicesConfig: state.home.allMedicalServicesConfig,
    attentionsSelected: state.home.attentionsSelected,
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    getAllMedicalServices: () => dispatch(actions.home.getAllMedicalServicesRequest()),
    approveAttention: (body) => dispatch(actions.home.approveAttentionRequest(body)),
    setAttentionForCreate: (attention) => dispatch(actions.home.setAttentionForCreate(attention)),
    setListConfig: (body) => dispatch(actions.home.setListConfig(body)),
    cleanListConfig: (list) => dispatch(actions.home.cleanListConfig(list)),
    setAttentionsSelected: (attentionsSelected) => dispatch(actions.home.setAttentionsSelected(attentionsSelected)),
});

MedicalServiceList.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    allMedicalServices: PropTypes.object,
    getAllMedicalServicesState: PropTypes.object,
    affiliateSelected: PropTypes.object,
    affiliateData: PropTypes.array,
    branchesProviders: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(MedicalServiceList);

